<template>
  <div class="container-fluid">
    <Breadcrumb :values="{ Home: '' }"></Breadcrumb>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              Site settings
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 d-flex flex-column">
                  <h4 class="mb-2">Change help view url:</h4>
                  <div class="input-wrapper mt-2">
                    <label>Help view url</label>
                    <div class="d-flex">
                      <el-input placeholder="E.g. /user/help"
                                v-model="url"
                                clearable></el-input>
                      <button class="search-button btn btn-block btn-outline-primary ml-3" type="button"
                              style="height: 40px;"
                              @click="setURL">Set url
                      </button>
                    </div>
                    <span class="mt-5 note-text">
                      Notes:
                      <br/> - After changing the url all users will have to refresh the page. Otherwise the help view will only be accessible from the old version of the url.
                      <br/> - The default protocol used is 'https://'. If the website you want to link to is not secured by a certificate you have to specify this in the url (e.g. 'http://www.url.com' instead of 'www.url.com')
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Breadcrumb from '../components/shared/Breadcrumb'
import generalActions from '../store/modules/general/actionTypes'

export default {
  name: 'AdminPanel',
  components: { Breadcrumb },
  data () {
    return {
      url: ''
    }
  },
  methods: {
    ...mapActions({
      setHelpUrl: generalActions.SET_HELP_URL,
      getHelpUrl: generalActions.GET_HELP_URL
    }),
    setURL () {
      this.setHelpUrl(this.url)
      this.$router.go()
    }
  },
  async mounted () {
    this.url = await this.getHelpUrl()
  }
}
</script>

<style scoped>
.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  font-size: 11px;
  color: #20a8d8;
  margin-bottom: 2px;
  margin-left: 2px;
}

.search-button {
  width: 120px;
  border-radius: 5px;
  margin-top: 0 !important;
}

.note-text {
  color: #8f8f8f;
  font-size: 12px;
}

</style>
